export class Alert {
    type: string;
    imei: string;
    vehiclename: string;
    objectlogtime: string;
    latitude: number;
    longitude: number;
    details: string;
}

export class AlertsResponse {
    Result: number;
    Reason: string;
    Response: Alert[];
}